import { useNavigate } from 'react-router-dom';
import { Footer } from '../First';

export function Cyber() {
  const navigate = useNavigate();

  const buttons = [
    { label: 'Cryptography', path: '/Crypto' },
    { label: 'Computer Network System', path: '/CNS' },
    { label: 'IDAM', path: '/IDAM' },
    { label: 'Application & Web Security', path: '/Web_Security' },
    { label: 'Sniffing / SQL Injection', path: '/Sniffing_SQLinjection' },
    { label: 'Session Hijacking', path: '/Hijacking' },
    { label: 'Community Groups', path: '/Cyber_Community', style: { marginTop: '10px' } },
  ];

  return (
    <>
      <div className="front_container">
        <div className="front_contain">
          <h2 className="fr_1">Cyber Security</h2>
          <p className="fr_2">
            All the resources are available through the links only. Kindly refer to this. We are providing the
            recommended platform not for any other promotions.
          </p>
          <p className="fr_rating">4.4 &#9733; &#9733; &#9733; &#9733;</p>
          <p>
            Created by{' '}
            <a
              href="https://www.linkedin.com/in/sayednowshad/"
              style={{ textDecoration: 'underline', fontSize: '17px', fontFamily: 'sans-serif' }}
            >
              SayedNowshad
            </a>
          </p>
        </div>
      </div>

      <h2 className="fr_des">Description</h2>
      <ul className="fr_list">
        <li className="fr_li">Click the below topics for more concepts to Unlock &#x1F512;</li>
        <li className="fr_li">See the topics listed and select the one you need.</li>
        <li className="fr_li">
          We provide all the facilities for searching and finding the best resources. Share this with your friends and
          spread it out.
        </li>
        <li className="fr_li">
          Thanks & Enjoy <strong>"Stay Hard &#x1F4AA;, Stay Consistently"</strong>
        </li>
      </ul>

      <h3 className="fr_cont">Content</h3>
      <div className="fr_butt">
        {buttons.map(({ label, path, style }) => (
          <button
            key={path}
            className="fr_butt_click"
            onClick={() => navigate(path)}
            style={style || {}}
          >
            {label}
          </button>
        ))}
      </div>

      <Footer />
    </>
  );
}

export default Cyber;
